import React from "react"
import {
  DashboardOutlined,
  BarChartOutlined,
  HistoryOutlined,
  ContainerOutlined,
  TeamOutlined,
  CommentOutlined,
  CodeOutlined,
  RobotOutlined,
  UserOutlined,
  ExperimentOutlined,
  WhatsAppOutlined,
  SettingOutlined,
  RocketOutlined,
  DeploymentUnitOutlined,
  CalendarOutlined,
  SoundOutlined,
  ContactsOutlined,
  AuditOutlined,
  AliwangwangOutlined,
  LineChartOutlined,
  PartitionOutlined,
} from "@ant-design/icons"

export const APP_LAYOUT = {
  APP_HEADER_HEIGHT: 60,
  APP_SIDER_COLLAPSE_WIDTH: 60,
  PAGE_BANNER_HEIGHT: 50,
  PAGE_NAVBAR_HEIGHT: 50,
  CHAT_LIST_HEADER_HEIGHT: 60,
  CHAT_LIST_TOGGLE_HEADER_HEIGHT: 45,
  CHAT_LIST_TOGGLE_HEIGHT: 32,
  CHAT_HEADER_HEIGHT: 60,
}

export const COLORS = {
  primary: "#64a45a",
  danger: "#ff6d4a",
  warning: "#f5a623",
  aquamarine: "#29bb9c",
  green: "#4CB25C",
  default: "#eff0f4",
  fontcolor: "#d9d9d9",
  fontcolor_light: "#b3b3b3",
}

export const PLATFORM = {
  //TODO: add all platform value
  WEBSITE: "website",
  FACEBOOK: "facebook",
  ANDROID: "android",
  IOS: "ios",
  WHATSAPP: "wa",
  IVR: "ivr",
}

export const ORIENTATION = {
  LANDSCAPE: "landscape",
  PORTRAIT: "portrait",
}

export const TEXT_TYPE = {
  USER_TYPED: "userTyped",
  CANNED_RESPONSE: "cannedResponse",
}

export const APP_SIDER_MENU_TYPE = {
  MENU_ITEM: "menu_item",
  SUB_MENU: "sub_menu",
  PAGE_TAB: "page_tab",
}

export const ROUTE_PATH = {
  AUTH: "/auth",
  LOGIN: "/auth/login",
  FORGOT_PASSWORD: "/auth/forgotpassword",
  RESET_PASSWORD: "/auth/resetpassword",
  ACTIVATE_USER: "/auth/activate",
  MICROSOFT_AUTHENTICATION: "/verify-ms-auth",
  DASHBOARD: "/",
  CHATS: "/chats",
  HISTORY: "/history",
  TICKET_HISTORY: "/tickethistory",
  ANALYTICS: "/analytics",
  CHATLOG_ANALYTICS: "/analytics/chatlog",
  USAGE_ANALYTICS: "/analytics/usages",
  EVENT_ANALYTICS: "/analytics/event",
  QUERY_ANALYTICS: "/analytics/query",
  GENERATIVE_ANALYTICS: "/analytics/genai",
  LIVE_CHAT_ANALYTICS: "/analytics/livechat",
  TICKET_ANALYTICS: "/analytics/ticket",
  BOT_SUCCESS_METRICS: "/analytics/botsuccessmetrics",
  SESSION_FLOW: "/analytics/sessionflow",
  CONVERSIONS: "/analytics/conversions",
  FEEDBACK: "/analytics/feedback",
  FRACTURE: "/analytics/fracture",
  MODEL_ACCURACY_ANALYTICS: "/analytics/accuracy",
  BOT_BUILDER: "/botbuilder",
  WORKFLOWS: "/botbuilder/workflows",
  WORKFLOW_DIAGRAM: "/botbuilder/workflows/:wid",
  BOT_MESSAGES: "/botbuilder/botmessages",
  EDIT_MESSAGE: "/botbuilder/botmessages/id=:messageId",
  BRAND_FUNCTIONS: "/botbuilder/brandfunctions",
  EDIT_BRAND_FUNCTION: "/botbuilder/brandfunctions/:brandFunctionId",
  EVENTS: "/botbuilder/events",
  BOT_PARAMS: "/botbuilder/botparams",
  INTENTS: "/botbuilder/intents",
  EDIT_INTENT: "/botbuilder/intents/:intentId",
  ENTITIES: "/botbuilder/entities",
  ENVIRONMENT_VARIABLES: "/botbuilder/environmentvariables",
  EDIT_ENTITY: "/botbuilder/entities/id=:entityId?&type=:entityType",
  CATALOGUE: "/botbuilder/catalogue",
  FAQ_BUILDER: "/botbuilder/faqbuilder",
  GENERATIVE_FAQ: "/botbuilder/generativefaq",
  EDIT_CATALOGUE_PRODUCT: "/botbuilder/catalogue/:productId",
  SETTINGS: "/settings",
  DOWNTIME: "/settings/downtime",
  PROFILE: "/settings/profile",
  TEAM_MEMBER_SETTING: "/settings/teammembers",
  MEMBER_PERMISSIONS: "/settings/teammembers/:memberId",
  BSV_CONFIGURATION: "/settings/bsv_configuration",
  CUSTOMERS: "/users",
  CUSTOMER_PROFILE: "/users/id=:cId&type=:cIdType",
  MEMBERS: "/members",
  AGENTS: "/members/agents",
  ROLES: "/members/roles",
  EDIT_ROLE: "/members/roles/individual",
  EDIT_AGENT_PROFILE: "/members/agents/edit",
  GROUPS: "/members/groups",
  ADD_GROUP: "/members/groups/add",
  EDIT_GROUP: "/members/groups/edit",
  CANNED_RESPONSES: "/members/canned_responses",
  TAGS: "/members/tags",
  AGENT_MONITORING: "/analytics/agent_monitoring",
  KPI: "/analytics/kpi",
  CONSOLE: "/console",
  REPORTS: "/console/reports",
  API_LOGS: "/console/apilogs",
  REPORTS_UI: "/console/reports_ui",
  WHATSAPP_TEMPLATE: "/whatsapp_template",
  TEMPLATE_MASTER: "/whatsapp_template/template_master",
  CREATE_TEMPLATE: "/whatsapp_template/template_master/create",
  SENDER: "/whatsapp_template/sender",
  BROADCAST_HISTORY: "/whatsapp_template/broadcast_history",
  TEMPLATE_RCA: "/whatsapp_template/template_cta",
  DIALOGUE_MANAGEMENT: "/dms",
  DOMAINS: "/dms/domains",
  DIALOGUES: "/dms/dialogues",
  ACTIONS: "/dms/actions",
  TRAINING_LOGS: "/dms/training_logs",
  WORKFLOW_TREE: "/dms/workflow_tree",
  USERS_JOURNEYS: "/dms/users_journey",
  JOURNEY_TREE: "/dms/users_journey/:journeyId",
  EDIT_DIALOGUE: "/dms/dialogues/:storyId",
  ML_CONFIGURATION: "/settings/ml_configuration",
  CONFIGURATION: "/members/configuration",
  AUTOMATED_TESTING: "/automatedtesting",
  TEST_CASES: "/automatedtesting/testcases",
  TEST_RUNS: "/automatedtesting/testruns",
  TEST_RESULTS: "/automatedtesting/testruns/testresults",
  TICKETS: "/tickets",
  TICKET_VIEW: "/tickets/:ticketId",
  MODEL_MANAGEMENT: "/modelmanagement",
  INTENTCLASSIFIER_MODEL: "/modelmanagement/intentclassifier_model",
  FAQ_MODEL: "/modelmanagement/faq_model",
  GENAI_CLASSIFIER: "/genaiclassifier",
  GENAI_INTENTS: "/genaiclassifier/intents",
  GENAI_FAQ: "/genaiclassifier/faq",
  CAMPAIGNS: "/campaignmanager/campaigns",
  CAMPAIGNS_DETAILS: "/campaignmanager/campaigns/:cId",
  CONTACTS: "/campaignmanager/contacts",
  CONTACTS_DETAILS: "/campaignmanager/contacts/:cId",
  CAMPAIGN_MANAGER: "/campaignmanager",
  VOICE_AGENTS: "/campaignmanager/voiceagents",
  EDIT_VOICE_AGENT: "/campaignmanager/voiceagents/:voiceagentId",
  CAMPAIGN_ANALYTICS: "/campaignmanager/analytics",
}

export const APP_PAGES = {
  LOGIN: "Login",
  FORGOT_PASSWORD: "Forgot Password",
  RESET_PASSWORD: "Reset Password",
  MICROSOFT_AUTHENTICATION: "Microsoft Authentication",
  DASHBOARD: "Dashboard",
  CHATS: "Chats",
  HISTORY: "Chat History",
  TICKET_HISTORY: "Ticket History",
  ANALYTICS: "Analytics",
  CHATLOG_ANALYTICS: "Chatlogs",
  USAGE_ANALYTICS: "Usages",
  EVENT_ANALYTICS: "Events Analytics",
  QUERY_ANALYTICS: "Query Analytics",
  GENERATIVE_ANALYTICS: "Generative AI Analytics",
  MODEL_ACCURACY_ANALYTICS: "Model Accuracy",
  LIVE_CHAT_ANALYTICS: "Live Chats",
  TICKET_ANALYTICS: "Ticket Analytics",
  FRACTURE: "Fracture Analytics",
  FEEDBACK: "Feedback",
  SESSION_FLOW: "Session Flow",
  BOT_SUCCESS_METRICS: "Bot Success Metrics",
  CONVERSIONS: "Conversions",
  BOT_BUILDER: "Bot Builder",
  WORKFLOWS: "Workflows",
  WORKFLOW_DIAGRAM: "Workflow Diagram",
  BOT_MESSAGES: "Messages",
  EDIT_MESSAGE: "Edit/Create Message",
  EDIT_ROLE: "Edit/Create Role",
  BRAND_FUNCTIONS: "Brand Functions",
  EDIT_BRAND_FUNCTION: "Edit Brand Function",
  EVENTS: "Events",
  BOT_PARAMS: "Bot Params",
  INTENTS: "Intents",
  EDIT_INTENT: "Edit Intent",
  ENTITIES: "Entities",
  ENVIRONMENT_VARIABLES: "Environment Variables",
  EDIT_ENTITY: "Edit Entity",
  EDIT_SIMPLE_ENTITY: "Edit simple entity",
  SETTINGS: "Settings",
  PROFILE: "Profile",
  TEAM_MEMBER_SETTING: "Team Member",
  MEMBER_PERMISSIONS: "User Permission",
  DOWNTIME: "Downtime",
  BSV_CONFIGURATION: "BSV Configuration",
  CUSTOMERS: "Customers",
  CUSTOMER_PROFILE: "Customer Profile",
  MEMBERS: "Members",
  AGENTS: "Agents",
  ROLES: "Roles",
  EDIT_AGENT_PROFILE: "Edit Agent Profile",
  GROUPS: "Groups",
  ADD_GROUP: "Add Group",
  EDIT_GROUP: "Edit Group",
  CANNED_RESPONSES: "Canned Responses",
  TAGS: "Tags",
  AGENT_MONITORING: "Agent Monitoring",
  KPI: "KPIs",
  CONSOLE: "Console",
  REPORTS: "Reports",
  API_LOGS: "API Logs",
  REPORTS_UI: "UI Reports Config",
  WHATSAPP_TEMPLATE: "WhatsApp Template",
  TEMPLATE_MASTER: "Template Master",
  CREATE_TEMPLATE: "Create Template",
  SENDER: "Sender",
  BROADCAST_HISTORY: "Broadcast History",
  TEMPLATE_RCA: "Template CTA",
  DIALOGUE_MANAGEMENT: "Dialogue Management",
  DOMAINS: "Domains",
  DIALOGUES: "Dialogues",
  ACTIONS: "Actions",
  TRAINING_LOGS: "Training Logs",
  WORKFLOW_TREE: "Workflow Tree",
  USERS_JOURNEYS: "Users Journey",
  JOURNEY_TREE: "Journey Tree",
  EDIT_DIALOGUE: "Edit Dialogue",
  ML_CONFIGURATION: "ML Configuration",
  CONFIGURATION: "Configuration",
  AUTOMATED_TESTING: "Automated Testing",
  TEST_CASES: "Test Cases",
  TEST_RUNS: "Test Runs",
  TEST_RESULTS: "Test Results",
  CATALOGUE: "Catalogue",
  EDIT_CATALOGUE: "Edit Catalogue",
  FAQ_BUILDER: "FAQ Builder",
  GENERATIVE_FAQ: "Generative FAQ",
  TICKETS: "Tickets",
  TICKET_VIEW: "Ticket View",
  MODEL_MANAGEMENT: "Model Management",
  INTENTCLASSIFIER_MODEL: "Intent Classifier",
  FAQ_MODEL: "FAQ Model",
  GENAI_CLASSIFIER: "GenAi Classifier",
  GENAI_INTENTS: "GenAi Intents",
  GENAI_FAQ: "FAQ",
  CAMPAIGNS_DETAILS: "Campaigns Details",
  CONTACTS_DETAILS: "Contacts Details",
  CAMPAIGNS: "Campaigns",
  CONTACTS: "Contacts",
  CAMPAIGN_MANAGER: "Campaign Manager",
  VOICE_AGENTS: "Agents",
  EDIT_VOICE_AGENT: "Voice Agents Details",
  CAMPAIGN_ANALYTICS: "Analytics",
}

export const SIDER_MENU = [
  {
    key: APP_PAGES.DASHBOARD,
    label: APP_PAGES.DASHBOARD,
    routepath: ROUTE_PATH.DASHBOARD,
    icon: <DashboardOutlined />,
  },
  {
    key: APP_PAGES.ANALYTICS,
    label: APP_PAGES.ANALYTICS,
    routepath: ROUTE_PATH.ANALYTICS,
    icon: <BarChartOutlined />,
    children: [
      {
        key: APP_PAGES.BOT_SUCCESS_METRICS,
        label: APP_PAGES.BOT_SUCCESS_METRICS,
        routepath: ROUTE_PATH.BOT_SUCCESS_METRICS,
      },
      {
        key: APP_PAGES.USAGE_ANALYTICS,
        label: APP_PAGES.USAGE_ANALYTICS,
        routepath: ROUTE_PATH.USAGE_ANALYTICS,
      },
      {
        key: APP_PAGES.CHATLOG_ANALYTICS,
        label: APP_PAGES.CHATLOG_ANALYTICS,
        routepath: ROUTE_PATH.CHATLOG_ANALYTICS,
      },
      {
        key: APP_PAGES.LIVE_CHAT_ANALYTICS,
        label: APP_PAGES.LIVE_CHAT_ANALYTICS,
        routepath: ROUTE_PATH.LIVE_CHAT_ANALYTICS,
      },
      {
        key: APP_PAGES.TICKET_ANALYTICS,
        label: APP_PAGES.TICKET_ANALYTICS,
        routepath: ROUTE_PATH.TICKET_ANALYTICS,
      },
      {
        key: APP_PAGES.EVENT_ANALYTICS,
        label: APP_PAGES.EVENT_ANALYTICS,
        routepath: ROUTE_PATH.EVENT_ANALYTICS,
      },
      {
        key: APP_PAGES.QUERY_ANALYTICS,
        label: APP_PAGES.QUERY_ANALYTICS,
        routepath: ROUTE_PATH.QUERY_ANALYTICS,
      },
      {
        key: APP_PAGES.GENERATIVE_ANALYTICS,
        label: APP_PAGES.GENERATIVE_ANALYTICS,
        routepath: ROUTE_PATH.GENERATIVE_ANALYTICS,
      },
      {
        key: APP_PAGES.MODEL_ACCURACY_ANALYTICS,
        label: APP_PAGES.MODEL_ACCURACY_ANALYTICS,
        routepath: ROUTE_PATH.MODEL_ACCURACY_ANALYTICS,
      },
      {
        key: APP_PAGES.AGENT_MONITORING,
        label: APP_PAGES.AGENT_MONITORING,
        routepath: ROUTE_PATH.AGENT_MONITORING,
      },
      {
        key: APP_PAGES.SESSION_FLOW,
        label: APP_PAGES.SESSION_FLOW,
        routepath: ROUTE_PATH.SESSION_FLOW,
      },
      {
        key: APP_PAGES.CONVERSIONS,
        label: APP_PAGES.CONVERSIONS,
        routepath: ROUTE_PATH.CONVERSIONS,
      },
      {
        key: APP_PAGES.FRACTURE,
        label: APP_PAGES.FRACTURE,
        routepath: ROUTE_PATH.FRACTURE,
      },
      {
        key: APP_PAGES.FEEDBACK,
        label: APP_PAGES.FEEDBACK,
        routepath: ROUTE_PATH.FEEDBACK,
      },
      {
        key: APP_PAGES.KPI,
        label: APP_PAGES.KPI,
        routepath: ROUTE_PATH.KPI,
      },
    ],
  },
  {
    key: APP_PAGES.CHATS,
    label: APP_PAGES.CHATS,
    routepath: ROUTE_PATH.CHATS,
    icon: <CommentOutlined />,
  },
  {
    key: APP_PAGES.HISTORY,
    label: APP_PAGES.HISTORY,
    routepath: ROUTE_PATH.HISTORY,
    icon: <HistoryOutlined />,
  },
  {
    key: APP_PAGES.TICKET_HISTORY,
    label: APP_PAGES.TICKET_HISTORY,
    routepath: ROUTE_PATH.TICKET_HISTORY,
    icon: <CalendarOutlined />,
  },
  {
    key: APP_PAGES.MODEL_MANAGEMENT,
    label: APP_PAGES.MODEL_MANAGEMENT,
    routepath: ROUTE_PATH.MODEL_MANAGEMENT,
    icon: <DeploymentUnitOutlined />,
    children: [
      {
        key: APP_PAGES.INTENTCLASSIFIER_MODEL,
        label: APP_PAGES.INTENTCLASSIFIER_MODEL,
        routepath: ROUTE_PATH.INTENTCLASSIFIER_MODEL,
      },
      {
        key: APP_PAGES.FAQ_MODEL,
        label: APP_PAGES.FAQ_MODEL,
        routepath: ROUTE_PATH.FAQ_MODEL,
      },
    ],
  },
  {
    key: APP_PAGES.GENAI_CLASSIFIER,
    label: APP_PAGES.GENAI_CLASSIFIER,
    routepath: ROUTE_PATH.GENAI_CLASSIFIER,
    icon: <PartitionOutlined />,
    children: [
      {
        key: APP_PAGES.GENAI_INTENTS,
        label: "Intents", // unique key to avoid duplicate highlight with botbuilder Intents
        routepath: ROUTE_PATH.GENAI_INTENTS,
      },
      {
        key: APP_PAGES.GENAI_FAQ,
        label: APP_PAGES.GENAI_FAQ,
        routepath: ROUTE_PATH.GENAI_FAQ,
      },
    ],
  },
  {
    key: APP_PAGES.BOT_BUILDER,
    label: APP_PAGES.BOT_BUILDER,
    routepath: ROUTE_PATH.BOT_BUILDER,
    icon: <RobotOutlined />,
    children: [
      {
        key: APP_PAGES.WORKFLOWS,
        label: APP_PAGES.WORKFLOWS,
        routepath: ROUTE_PATH.WORKFLOWS,
      },
      {
        key: APP_PAGES.INTENTS,
        label: APP_PAGES.INTENTS,
        routepath: ROUTE_PATH.INTENTS,
      },
      {
        key: APP_PAGES.ENTITIES,
        label: APP_PAGES.ENTITIES,
        routepath: ROUTE_PATH.ENTITIES,
      },
      {
        key: APP_PAGES.ENVIRONMENT_VARIABLES,
        label: APP_PAGES.ENVIRONMENT_VARIABLES,
        routepath: ROUTE_PATH.ENVIRONMENT_VARIABLES,
      },
      {
        key: APP_PAGES.BOT_MESSAGES,
        label: APP_PAGES.BOT_MESSAGES,
        routepath: ROUTE_PATH.BOT_MESSAGES,
      },
      {
        key: APP_PAGES.EVENTS,
        label: APP_PAGES.EVENTS,
        routepath: ROUTE_PATH.EVENTS,
      },
      {
        key: APP_PAGES.BOT_PARAMS,
        label: APP_PAGES.BOT_PARAMS,
        routepath: ROUTE_PATH.BOT_PARAMS,
      },
      {
        key: APP_PAGES.BRAND_FUNCTIONS,
        label: APP_PAGES.BRAND_FUNCTIONS,
        routepath: ROUTE_PATH.BRAND_FUNCTIONS,
      },
      {
        key: APP_PAGES.CATALOGUE,
        label: APP_PAGES.CATALOGUE,
        routepath: ROUTE_PATH.CATALOGUE,
      },
      {
        key: APP_PAGES.FAQ_BUILDER,
        label: APP_PAGES.FAQ_BUILDER,
        routepath: ROUTE_PATH.FAQ_BUILDER,
      },
      {
        key: APP_PAGES.GENERATIVE_FAQ,
        label: APP_PAGES.GENERATIVE_FAQ,
        routepath: ROUTE_PATH.GENERATIVE_FAQ,
      },
    ],
  },
  {
    key: APP_PAGES.TICKETS,
    label: APP_PAGES.TICKETS,
    routepath: ROUTE_PATH.TICKETS,
    icon: <ContainerOutlined />,
  },
  {
    key: APP_PAGES.CUSTOMERS,
    label: APP_PAGES.CUSTOMERS,
    routepath: ROUTE_PATH.CUSTOMERS,
    icon: <TeamOutlined />,
  },
  {
    key: APP_PAGES.MEMBERS,
    label: APP_PAGES.MEMBERS,
    routepath: ROUTE_PATH.MEMBERS,
    icon: <UserOutlined />,
    children: [
      {
        key: APP_PAGES.AGENTS,
        label: APP_PAGES.AGENTS,
        routepath: ROUTE_PATH.AGENTS,
      },
      {
        key: APP_PAGES.GROUPS,
        label: APP_PAGES.GROUPS,
        routepath: ROUTE_PATH.GROUPS,
      },
      {
        key: APP_PAGES.ROLES,
        label: APP_PAGES.ROLES,
        routepath: ROUTE_PATH.ROLES,
      },
      {
        key: APP_PAGES.CANNED_RESPONSES,
        label: APP_PAGES.CANNED_RESPONSES,
        routepath: ROUTE_PATH.CANNED_RESPONSES,
      },
      {
        key: APP_PAGES.TAGS,
        label: APP_PAGES.TAGS,
        routepath: ROUTE_PATH.TAGS,
      },
      {
        key: APP_PAGES.CONFIGURATION,
        label: APP_PAGES.CONFIGURATION,
        routepath: ROUTE_PATH.CONFIGURATION,
      },
    ],
  },
  {
    key: APP_PAGES.CONSOLE,
    label: APP_PAGES.CONSOLE,
    routepath: ROUTE_PATH.CONSOLE,
    icon: <CodeOutlined />,
    children: [
      {
        key: APP_PAGES.API_LOGS,
        label: APP_PAGES.API_LOGS,
        routepath: ROUTE_PATH.API_LOGS,
      },
      {
        key: APP_PAGES.REPORTS,
        label: APP_PAGES.REPORTS,
        routepath: ROUTE_PATH.REPORTS,
      },
      {
        key: APP_PAGES.REPORTS_UI,
        label: APP_PAGES.REPORTS_UI,
        routepath: ROUTE_PATH.REPORTS_UI,
      },
    ],
  },
  {
    key: APP_PAGES.AUTOMATED_TESTING,
    label: APP_PAGES.AUTOMATED_TESTING,
    routepath: ROUTE_PATH.AUTOMATED_TESTING,
    icon: <ExperimentOutlined />,
    children: [
      {
        key: APP_PAGES.TEST_CASES,
        label: APP_PAGES.TEST_CASES,
        routepath: ROUTE_PATH.TEST_CASES,
      },
      {
        key: APP_PAGES.TEST_RUNS,
        label: APP_PAGES.TEST_RUNS,
        routepath: ROUTE_PATH.TEST_RUNS,
      },
    ],
  },
  {
    key: APP_PAGES.DIALOGUE_MANAGEMENT,
    label: APP_PAGES.DIALOGUE_MANAGEMENT,
    routepath: ROUTE_PATH.DIALOGUE_MANAGEMENT,
    icon: <RocketOutlined />,
    children: [
      {
        key: APP_PAGES.DIALOGUES,
        label: APP_PAGES.DIALOGUES,
        routepath: ROUTE_PATH.DIALOGUES,
      },
      {
        key: APP_PAGES.DOMAINS,
        label: APP_PAGES.DOMAINS,
        routepath: ROUTE_PATH.DOMAINS,
      },
      {
        key: APP_PAGES.ACTIONS,
        label: APP_PAGES.ACTIONS,
        routepath: ROUTE_PATH.ACTIONS,
      },
      {
        key: APP_PAGES.TRAINING_LOGS,
        label: APP_PAGES.TRAINING_LOGS,
        routepath: ROUTE_PATH.TRAINING_LOGS,
      },
      {
        key: APP_PAGES.WORKFLOW_TREE,
        label: APP_PAGES.WORKFLOW_TREE,
        routepath: ROUTE_PATH.WORKFLOW_TREE,
      },
      {
        key: APP_PAGES.USERS_JOURNEYS,
        label: APP_PAGES.USERS_JOURNEYS,
        routepath: ROUTE_PATH.USERS_JOURNEYS,
      },
    ],
  },
  {
    key: APP_PAGES.CAMPAIGN_MANAGER,
    label: APP_PAGES.CAMPAIGN_MANAGER,
    routepath: ROUTE_PATH.CAMPAIGN_MANAGER,
    icon: <AuditOutlined />,
    children: [
      {
        key: APP_PAGES.CAMPAIGNS,
        label: APP_PAGES.CAMPAIGNS,
        routepath: ROUTE_PATH.CAMPAIGNS,
        icon: <SoundOutlined />,
      },
      {
        key: APP_PAGES.CONTACTS,
        label: APP_PAGES.CONTACTS,
        routepath: ROUTE_PATH.CONTACTS,
        icon: <ContactsOutlined />,
      },
      {
        key: APP_PAGES.VOICE_AGENTS,
        label: APP_PAGES.VOICE_AGENTS,
        routepath: ROUTE_PATH.VOICE_AGENTS,
        icon: <AliwangwangOutlined />,
      },
      {
        key: APP_PAGES.CAMPAIGN_ANALYTICS,
        label: APP_PAGES.CAMPAIGN_ANALYTICS,
        routepath: ROUTE_PATH.CAMPAIGN_ANALYTICS,
        icon: <LineChartOutlined />,
      },
    ],
  },
  {
    key: APP_PAGES.WHATSAPP_TEMPLATE,
    label: APP_PAGES.WHATSAPP_TEMPLATE,
    routepath: ROUTE_PATH.WHATSAPP_TEMPLATE,
    icon: <WhatsAppOutlined />,
    children: [
      {
        key: APP_PAGES.TEMPLATE_MASTER,
        label: APP_PAGES.TEMPLATE_MASTER,
        routepath: ROUTE_PATH.TEMPLATE_MASTER,
      },
      {
        key: APP_PAGES.SENDER,
        label: APP_PAGES.SENDER,
        routepath: ROUTE_PATH.SENDER,
      },
      {
        key: APP_PAGES.BROADCAST_HISTORY,
        label: APP_PAGES.BROADCAST_HISTORY,
        routepath: ROUTE_PATH.BROADCAST_HISTORY,
      },
      {
        key: APP_PAGES.TEMPLATE_RCA,
        label: APP_PAGES.TEMPLATE_RCA,
        routepath: ROUTE_PATH.TEMPLATE_RCA,
      },
    ],
  },
  {
    key: APP_PAGES.SETTINGS,
    label: APP_PAGES.SETTINGS,
    routepath: ROUTE_PATH.SETTINGS,
    icon: <SettingOutlined />,
    children: [
      {
        key: APP_PAGES.DOWNTIME,
        label: APP_PAGES.DOWNTIME,
        routepath: ROUTE_PATH.DOWNTIME,
      },
      {
        key: APP_PAGES.PROFILE,
        label: APP_PAGES.PROFILE,
        routepath: ROUTE_PATH.PROFILE,
      },
      {
        key: APP_PAGES.TEAM_MEMBER_SETTING,
        label: APP_PAGES.TEAM_MEMBER_SETTING,
        routepath: ROUTE_PATH.TEAM_MEMBER_SETTING,
      },
      {
        key: APP_PAGES.ML_CONFIGURATION,
        label: APP_PAGES.ML_CONFIGURATION,
        routepath: ROUTE_PATH.ML_CONFIGURATION,
      },
      {
        key: APP_PAGES.BSV_CONFIGURATION,
        label: APP_PAGES.BSV_CONFIGURATION,
        routepath: ROUTE_PATH.BSV_CONFIGURATION,
      },
    ],
  },
]

export const PERMISSIONS = {
  ACTION_TYPES: {
    CREATE: "create",
    UPDATE: "update",
    READ: "read",
    DELETE: "delete",
  },
  ACTIONS: {
    INTENT: "intent",
    ENTITY: "entity",
    WORKFLOW: "workflow",
    BOT_MESSAGE: "botMessage",
    EVENT: "event",
    INSIGHT: "insight",
    BOT_DEVELOPMENT: "botDevelopment",
    TRAIN_MESSAGES: "trainMessages",
    TEAM_MANAGEMENT: "teamManagement",
    UTTERANCE: "utterance",
  },
  EVENTS: {
    TAKEOVER: "takeover",
  },
}

export const ENTITY_TYPES = {
  SIMPLE: "simple",
  HIERARCHICAL: "hierarchical",
  LIST: "list",
}
